import { RouteName } from "../RouteNames";

export const stakeholdersRoutes = [
  {
    name: RouteName.StakeholdersRoot,
    path: "stakeholders",
    component: () =>
      import(
        "@follaw-fr/views/side_menu_views/SocialMediaStakeholdersView.vue"
      ),
    children: [
      {
        name: RouteName.Stakeholders,
        path: "",
        redirect: () => ({ name: RouteName.StakeholderRanking }),
      },
      {
        name: RouteName.StakeholderRanking,
        path: "ranking",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/StakeholdersRankingView.vue"
          ),
        redirect: () => ({ name: RouteName.StakeholderRankingList }),
        children: [
          {
            path: "",
            name: RouteName.StakeholderRankingList,
            component: () =>
              import(
                "@follaw-fr/views/social-media/stakeholders/StakeholdersRankingView.vue"
              ),
          },
          {
            name: RouteName.StakeholderRankingFollawed,

            path: "follawed",
            component: () =>
              import(
                "@follaw-fr/views/social-media/stakeholders/StakeholdersRankingView.vue"
              ),
          },
        ],
      },
      {
        name: RouteName.StakeholderPoliticalMap,
        path: "political",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/StakeholdersPoliticalView.vue"
          ),
      },
      {
        name: RouteName.StakeholderSocietalMap,

        path: "social",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/StakeholdersSocialView.vue"
          ),
      },
    ],
  },
  {
    name: RouteName.StakeholderZoom,
    path: "stakeholders/:_id",
    component: () =>
      import(
        "@follaw-fr/views/social-media/stakeholders/StakeholdersZoomView.vue"
      ),
    children: [
      {
        name: RouteName.StakeholderZoomPreview,

        path: "preview",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/PreviewZoomView.vue"
          ),
      },
      {
        name: RouteName.StakeholderZoomPublications,

        path: "publications",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/PublicationsZoomView.vue"
          ),
      },
      {
        name: RouteName.StakeholderZommMentions,

        path: "mentions",
        component: () =>
          import(
            "@follaw-fr/views/social-media/stakeholders/MentionsZoomView.vue"
          ),
      },
    ],
  },
];
